// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c56dcc0a","205":"b41e59e2","209":"e382ada0","256":"cdab372b","403":"a719f026","427":"ffb0d26b","457":"083d0cba","551":"80394b2d","617":"8d5f247e","672":"16d167b3","842":"b193a3c5","851":"7e5e7c3d"}[chunkId] + ".chunk.js";
};